export default __webpack_public_path__ + "static/media/video-tape.146af964.svg";